/* =========================================================
   WOMUSE — COMPLIMENTARY GIFT COUNTDOWN
   Version 1.0
   ========================================================= */

(function () {
  "use strict";

  function initGift(gift) {
    if (gift.dataset.initialized === "true") return;

    gift.dataset.initialized = "true";

    const expiry = gift.dataset.expiry;
    const behavior = gift.dataset.expiredBehavior;
    const showCountdown = gift.dataset.showCountdown === "true";

    const countdown = gift.querySelector(
      "[data-womuse-gift-countdown]"
    );

    if (!expiry) return;

    const endTime = new Date(expiry).getTime();

    if (Number.isNaN(endTime)) {
      console.warn("WOMUSE: Invalid gift expiry date.");
      return;
    }

    let interval;

    function updateCountdown() {
      const remaining = endTime - Date.now();

      if (remaining <= 0) {
        if (interval) clearInterval(interval);

        if (behavior === "hide") {
          gift.hidden = true;
        } else if (countdown) {
          countdown.textContent = "Expired";
        }

        return;
      }

      if (!showCountdown || !countdown) return;

      const totalSeconds = Math.floor(remaining / 1000);

      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      const pad = (value) => String(value).padStart(2, "0");

      countdown.textContent =
        (days > 0 ? days + "d " : "") +
        pad(hours) + ":" +
        pad(minutes) + ":" +
        pad(seconds);
    }

    updateCountdown();

    if (endTime > Date.now()) {
      interval = setInterval(updateCountdown, 1000);
    }
  }

  function initAll() {
    document
      .querySelectorAll("[data-womuse-gift]")
      .forEach(initGift);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", initAll);
})();